"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const manifesto = ["El fulcro es el punto de apoyo de una palanca. Sin él, la fuerza no se multiplica — solo se desperdicia. Una palanca larga sin fulcro correcto no mueve nada; agrega esfuerzo sin resultado.", "La mayoría de proyectos de automatización fracasan por eso: compran palancas cada vez más sofisticadas sin diagnosticar dónde apoyarlas.", "Antes de automatizar, diagnosticamos. Antes de elegir una herramienta, entendemos el problema. Antes de proponer IA, validamos que sea la respuesta correcta.", "Usamos tecnología, pero no somos tecnología. Somos un criterio de rentabilidad.", "Las modas pasan — la IA de moda hoy no será la de moda en dos años — pero el principio no cambia: lo que no multiplica el resultado es costo disfrazado de innovación.", "Por eso resolvemos con un script de doce líneas cuando el cliente esperaba un modelo de IA. Recomendamos no integrar cuando el proceso aún no está claro. Decimos: no es tecnología lo que necesita — es criterio operativo.", "La tecnología correcta, en el punto exacto, multiplica el negocio. La incorrecta, por sofisticada que sea, solo agrega costo."];
export default function Manifiesto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="222684" id="manifiesto" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={`max-w-3xl mx-auto px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal text-foreground leading-tight mb-12">
          No somos la palanca. Somos el criterio de dónde ponerla.
        </h2>

        <div className="space-y-6 text-foreground/90 font-sans text-lg leading-relaxed">
          {manifesto.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
        </div>
      </div>
    </section>;
}